module.exports = __webpack_public_path__ + "static/media/third.9db9e7e5.jpg";